import { tap, switchMap, startWith, catchError } from 'rxjs/operators';
import { Observable, of, EMPTY } from 'rxjs';

import { AnySort, IList, IListState, ISort } from '../models';
import { Loader } from '../classes/loader.class';
import { AppConstants } from '../config';

export function isInBulkEditLimit(list): boolean {
	const count = list?.paging?.totalItemCount
	return count > 0 && count <= AppConstants.BULK_EDIT_MAX_SIZE
}

export function wrapListWithLoader<T>(source$: Observable<IList<T>>, loader: Loader): Observable<IList<T>> {
	return of(null).pipe(
		tap(_ => loader.loading(true)),
		switchMap(_ => source$.pipe(
			tap(_ => loader.loading(false)),
			startWith({ items: [] })
		)),
		catchError(_ => {
			loader.error(_);
			return EMPTY;
		})
	);
}

export function emptyList<T>(): IList<T> {
	return {
		items: [],
	}
}

// Creates a default list state (page 1, default pagination) with a default sort if provided
export function createDefaultListState<T>(defaultSort?: T, isDesc = false, pageSize: number = AppConstants.LIST_PAGE_SIZE_DEFAULT): IListState<T> {
	const returned: IListState<T> = {
		sorts: [],
		pageSize: pageSize,
		page: 1
	};

	if (defaultSort) {
		returned.sorts = [{
			prop: defaultSort,
			isDesc: isDesc
		}];
	}

	return returned;
}

export function createDefaultListStateAnySort<T>(defaultSort?: AnySort<T>, pageSize: number = AppConstants.LIST_PAGE_SIZE_DEFAULT): IListState<T> {
	const returned: IListState<T> = {
		sorts: [],
		pageSize: pageSize,
		page: 1
	};

	if (!Array.isArray(defaultSort)) {
		returned.sorts = [{ prop: defaultSort, isDesc: false }]

	} else if (typeof defaultSort[0] === 'object') {
		returned.sorts = defaultSort as ISort<T>[]

	} else if (Array.isArray(defaultSort[0])) {
		returned.sorts = (defaultSort as [T, boolean][])
			.map(([ prop, isDesc ]) => ({
				prop, isDesc }));
	} else {
		const [ prop, isDesc ] = defaultSort
		returned.sorts = [{ prop, isDesc: !!isDesc }]
	}

	return returned;
}
